module.exports = __webpack_public_path__ + "static/mobile-grid-184e52cc91eb06560fea0fd588630aad.png";